import dynamic from 'next/dynamic'
import { Fragment } from 'react'
import { Popover, Transition } from '@headlessui/react'
import WalletSelect from 'components/ConnectWallet/WalletSelect'
import useConnectWallet from 'components/ConnectWallet/ConnectWallet.hooks'
import AddressBalance from 'components/ConnectWallet/AddressBalance'
import { PROVIDER_ID } from 'wallet/constants'

const MenuButton = dynamic(() => import('components/ConnectWallet/MenuButton'), { ssr: false })

export default function ConnectWallet() {
  const {
    walletManager,
    wallet,
    popperStyles,
    popperAttributes,
    setReferenceElement,
    setPopperElement,
    handleConnectWallet,
    handleDisconnectWallet,
    handleSetActiveAccount,
    hasConnectedAccount
  } = useConnectWallet()

  const renderAddressBalance = () => {
    return (
      wallet.activeAccount?.address && (
        <div className="flex items-center px-5 py-4 bg-gray-100 rounded-md text-base font-medium mb-4">
          <AddressBalance address={wallet.activeAccount.address} balance={wallet.walletBalance} />
        </div>
      )
    )
  }

  const renderWalletProviders = () => {
    return walletManager.providers
      .filter(
        ({ id }) =>
          !(process.env.NEXT_PUBLIC_VERCEL_ENV === 'betanet' && id === PROVIDER_ID.PERA_WALLET)
      )
      .map(({ id, icon, name, isConnected, isActive }) => (
        <li key={id} className="flex flex-col justify-stretch">
          <WalletSelect
            providerId={id}
            name={name}
            icon={icon}
            isConnected={isConnected}
            accounts={walletManager.getAccountsByProvider(id)}
            activeAccount={wallet.activeAccount}
            isActive={isActive}
            handleConnectWallet={handleConnectWallet}
            handleDisconnectWallet={handleDisconnectWallet}
            handleSetActiveAccount={handleSetActiveAccount}
          />
        </li>
      ))
  }

  return (
    <Popover>
      <MenuButton
        setReferenceElement={setReferenceElement}
        activeAccount={wallet.activeAccount}
        hasConnectedAccount={hasConnectedAccount}
        walletBalance={wallet.walletBalance}
      />
      <Popover.Panel
        ref={setPopperElement}
        style={popperStyles.popper}
        {...popperAttributes.popper}
      >
        <Transition
          as={Fragment}
          enter="transition ease-out duration-200"
          enterFrom="opacity-0 translate-y-1"
          enterTo="opacity-100 translate-y-0"
          leave="transition ease-in duration-150"
          leaveFrom="opacity-100 translate-y-0"
          leaveTo="opacity-0 translate-y-1"
        >
          <div className="bg-white shadow-lg w-screen p-5 sm:max-w-xl sm:rounded-b-lg border-t border-gray-100">
            {renderAddressBalance()}
            <div className="grid grid-cols-2">
              <ul role="list" className="space-y-4 col-span-2">
                {renderWalletProviders()}
              </ul>
            </div>
          </div>
        </Transition>
      </Popover.Panel>
    </Popover>
  )
}
